import { combineReducers } from '@reduxjs/toolkit';
import { journalEntriesSlice } from './slices/journalEntriesSlice';
import { journalEntryLogsSlice } from './slices/journalEntryLogsSlice';
import { expectedInternalTransfersSlice } from './slices/expectedInternalTransfersSlice';
import { bankAccountListSlice } from './slices/bankAccountListSlice';
import { createInternalTransferSlice } from './slices/createInternalTransferSlice';
import { ordersSearchSlice } from '../orders';
import { environmentSlice } from 'store/environment/environmentSlice';

export const accountingReducer = combineReducers({
  bankAccountList: bankAccountListSlice.reducer,
  journalEntries: journalEntriesSlice.reducer,
  journalEntryLogs: journalEntryLogsSlice.reducer,
  ordersSearch: ordersSearchSlice.reducer,
  expectedInternalTransfers: expectedInternalTransfersSlice.reducer,
  createInternalTransfer: createInternalTransferSlice.reducer,
  environmentSlice: environmentSlice.reducer,
});
